import { Injectable } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { UserService } from '../user.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

export class ColumnOrderConfiguration {
  pageName: string;
  columns: any[];
}

export class BasicColumnOrderConfiguration {
  pageName: string;
  columns: any[];
}

interface ColumnOrderChanges {
  type: string;
  changes: any;
}
/*
interface DeepReadonlyArray<T> extends ReadonlyArray<DeepReadonly<T>> {}

type DeepReadonly<T> =
  T extends (infer R)[] ? DeepReadonlyArray<R> :
  T extends Function ? T :
  T extends object ? DeepReadonlyObject<T> :
  T;


type DeepReadonlyObject<T> = {
  readonly [P in keyof T]: DeepReadonly<T[P]>;
}; */


@Injectable({
  providedIn: 'root'
})
export class ColumnsOrdersService{



  displayedColumnsConfig: ColumnOrderConfiguration[] = [];

  dialogRef: MatDialogRef<any>;

  isAdmin: number;
  hasBilling: number;
  dialogSubscription: Subscription;
  basicConf: Subscription;
  // basicColumnsConfig: DeepReadonlyArray<BasicColumnOrderConfiguration>;
  basicColumnsConfig$: Observable<BasicColumnOrderConfiguration>;
  private basicColumnsSubject = new BehaviorSubject<BasicColumnOrderConfiguration>(null);

  constructor(private dialog: MatDialog, private snackBar: MatSnackBar,
              private userService: UserService) {


    this.basicColumnsConfig$ = this.basicColumnsSubject.asObservable();
  }

  createBasicConfObservable(pageName) {
    const data = [
      {
        pageName: 'DLR Undel MCC',
        columns: [
          {name: 'selected', displayedName: '', order : 0, visible: true, rightsNeeded: 'none', width: 50},
          /* {name: 'client_text', displayedName: 'Account', order : 1, visible: true, rightsNeeded: 'none', width: 340}, */
          {name: 'mcc_country', displayedName: 'MCC (Country)', order : 2, visible: true, rightsNeeded: 'none', width: 300},
          {name: 'destination_count', displayedName: 'MSISDN Count', order : 3, visible: true, rightsNeeded: 'none', width: 300},
        ]
      },
      {
        pageName: 'DLR Undel MSISDN',
        columns: [
          {name: 'selected', displayedName: '', order : 0, visible: true, rightsNeeded: 'none', width: 50},
          /* {name: 'client_text', displayedName: 'Account', order : 1, visible: true, rightsNeeded: 'none', width: 340}, */
          {name: 'mcc_country', displayedName: 'MCC (Country)', order : 2, visible: true, rightsNeeded: 'none', width: 300},
          {name: 'destination', displayedName: 'MSISDN', order : 3, visible: true, rightsNeeded: 'none', width: 300},
          {name: 'expiry_timestamp', displayedName: 'Expire On (GMT)', order : 4, visible: true, rightsNeeded: 'none', width: 300},
          {name: 'create_timestamp', displayedName: 'Created On (GMT)', order : 5, visible: true, rightsNeeded: 'none', width: 300},
        ]
      },
      {
        pageName: 'DLR Policies',
        columns: [
          {name: 'selected', displayedName: '', order : 0, visible: true, rightsNeeded: 'none', width: 50},
          /* {name: 'client_text', displayedName: 'Account', order : 1, visible: true, rightsNeeded: 'none', width: 250}, */
          {name: 'mcc_country', displayedName: 'MCC (Country)', order : 2, visible: true, rightsNeeded: 'none', width: 250},
          {name: 'sid_regex', displayedName: 'SID Regex', order : 3, visible: true, rightsNeeded: 'none', width: 250},
          {name: 'dest_regex', displayedName: 'Content Regex', order : 4, visible: true, rightsNeeded: 'none', width: 250},
          {name: 'delivery_prcn', displayedName: 'DLR%', order : 5, visible: true, rightsNeeded: 'none', width: 100},
          {name: 'undel_cache_expiry_hrs', displayedName: 'UNDEL Cache Expiry Hrs', order : 6, visible: true,
            rightsNeeded: 'none', width: 100},
          {name: 'delay_five', displayedName: '3-5s', order : 7, visible: true, rightsNeeded: 'none', width: 100},
          {name: 'delay_ten', displayedName: '6-10s', order : 8, visible: true, rightsNeeded: 'none', width: 100},
          {name: 'delay_twenty', displayedName: '11-20s', order : 9, visible: true, rightsNeeded: 'none', width: 100},
          {name: 'delay_thirty', displayedName: '21-30s', order : 10, visible: true, rightsNeeded: 'none', width: 100},
          {name: 'delay_forty', displayedName: '31-40s', order : 11, visible: true, rightsNeeded: 'none', width: 100},
          {name: 'delay_sixty', displayedName: '41-60w', order : 12, visible: true, rightsNeeded: 'none', width: 100},
          {name: 'delay_three_hundred', displayedName: '60-300s', order : 13, visible: true, rightsNeeded: 'none', width: 100},
          {name: 'delay_six_hundred', displayedName: '300-600s', order : 14, visible: true, rightsNeeded: 'none', width: 100},
          {name: 'login', displayedName: 'User', order : 15, visible: false, rightsNeeded: 'none', width: 200},
          {name: 'create_timestamp', displayedName: 'Updated On (GMT)', order : 16, visible: true, rightsNeeded: 'none', width: 180},
          {name: 'update_timestamp', displayedName: 'Created On (GMT)', order : 17, visible: true, rightsNeeded: 'none', width: 180},
        ]
      },
      {
        pageName: 'DLR Response Summary',
        columns: [
          {name: 'time', displayedName: 'Time', order : 0, visible: true, rightsNeeded: 'none', width: 'max-content'},
          /* {name: 'account', displayedName: 'Account', order : 1, visible: true, rightsNeeded: 'none', width: 'max-content'}, */
          {name: 'mcc', displayedName: 'MCC (Country)', order : 2, visible: true, rightsNeeded: 'none', width: 'max-content'},
          {name: 'delivered', displayedName: 'DELIVERED', order : 3, visible: true, rightsNeeded: 'none', width: 'max-content'},
          {name: 'undelivered', displayedName: 'UNDELIVERED', order : 4, visible: true, rightsNeeded: 'none', width: 'max-content'},
          /* {name: 'pending', displayedName: 'PENDING', order : 5, visible: true, rightsNeeded: 'none', width: 'max-content'}, */
          {name: 'del_percent', displayedName: '% of DEL', order : 6, visible: true, rightsNeeded: 'none', width: 'max-content'},
          {name: 'undel_percent', displayedName: '% of UNDEL', order : 7, visible: true, rightsNeeded: 'none', width: 'max-content'}/* ,
          {name: 'pending_percent', displayedName: '% of PEND', order : 8, visible: true, rightsNeeded: 'none', width: 'max-content'} */
        ]
      },
      {
        pageName: 'Clicker Summary',
        columns: [
          {name: 'mcc', displayedName: 'MCC (Country)', order : 0, visible: true, rightsNeeded: 'none', width: 'max-content'},
          {name: 'ctr', displayedName: 'CTR', order : 1, visible: true, rightsNeeded: 'none', width: 'max-content'},
          /* {name: 'success_rate', displayedName: 'Success Rate', order : 2, visible: true, rightsNeeded: 'none', width: 'max-content'}, */
          {name: 'traffic', displayedName: 'Traffic', order : 3, visible: true, rightsNeeded: 'none', width: 'max-content'},
          {name: 'traffic_with_link', displayedName: 'Traffic with link', order : 4, visible: true, rightsNeeded: 'none', width: 'max-content'}
        ]
      }
    ] ;
    const conf = data.find(cf => cf.pageName === pageName);
    this.basicColumnsSubject.next(conf);
  }

  getBasicColumnsConfig(): Observable<BasicColumnOrderConfiguration> {
    return this.basicColumnsConfig$;
  }

  openSnackBar(message: Array<string>) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: message
    });
  }

  checkColumnVisibleForUser(column: any) {
    switch (column.rightsNeeded) {
      case 'none':
        return true;
      case 'admin':
        return this.isAdmin === 1 ? true : false;
      case 'billing':
        return this.hasBilling === 1 ? true : false;
      case 'adminOrBilling':
        return this.hasBilling === 1 || this.isAdmin === 1 ? true : false;
      case 'adminAndBilling':
        return this.hasBilling === 1 && this.isAdmin === 1 ? true : false;
    }

  }

  getColumnsOrder(tabCode: string) {

      const index = this.displayedColumnsConfig.findIndex(item => item.pageName === tabCode);

      if (index > -1) {
        return this.displayedColumnsConfig[index].columns.filter(col => this.checkColumnVisibleForUser(col));
      } else {
        return [];
/*           console.log('conf', conf);
          const basicConf = conf.columns;
          console.log('basicConf', basicConf, basicConf.filter(col => this.checkColumnVisibleForUser(col)));

          const model = new ColumnOrderConfiguration();
          model.pageName = tabCode;
          model.columns = basicConf;
          this.displayedColumnsConfig.push(model);

          return basicConf.filter(col => this.checkColumnVisibleForUser(col)); */
      }
  }

  createConf(page: string, cols) {
    const found = this.displayedColumnsConfig.find(item => item.pageName === page);
    if (found) {
      found.columns = cols;
    } else {
      const model = new ColumnOrderConfiguration();
      model.pageName = page;
      model.columns = cols;
      this.displayedColumnsConfig.push(model);
    }
  }

  setColWidth(page: string, colName, width) {
    const index = this.displayedColumnsConfig.findIndex(item => item.pageName === page);
    if (index > -1) {
      const found = this.displayedColumnsConfig[index].columns.find(col => col.name === colName);
      if (found) {
        found.width = width;
      }
    }
  }

}
